import React from "react";
import SwitchSetting, { ISwitchSetting } from "./switchSetting";
import "../styles/conferenceSettings.css";

type SwitchSetAction = React.Dispatch<React.SetStateAction<0 | 1>>;

export interface IChangeEventActions {
  accessMicro: boolean;
  accessVideo: boolean;
  accessWaitingHall: boolean;
  accessDemonstration: boolean;
  setAccessMicro: SwitchSetAction;
  setAccessVideo: SwitchSetAction;
  setAccessWaitingHall: SwitchSetAction;
  setAccessDemonstration: SwitchSetAction;
}

interface ISwitches extends Omit<ISwitchSetting, "onChange"> {
  label: string;
  onChange: SwitchSetAction;
}

const ConferenceSettings: React.FC<IChangeEventActions> = (props: IChangeEventActions): React.JSX.Element => {
  const onChangeSwitch = (isChecked: boolean, callback: SwitchSetAction) => {
    callback(isChecked ? 1 : 0);
  };
  const switches: ISwitches[] = [
    {
      label: "Микрофоны",
      checked: props.accessMicro,
      onChange: props.setAccessMicro,
      "data-testid": "accessMicro",
    },
    {
      label: "Видео",
      checked: props.accessVideo,
      onChange: props.setAccessVideo,
      "data-testid": "accessVideo",
    },
    {
      label: "Демонстрацию экрана",
      checked: props.accessDemonstration,
      onChange: props.setAccessDemonstration,
      "data-testid": "accessDemonstration",
    },
  ];

  return (
    <div className="conferenceSettings">
      <div className="conferenceSettings__title">Безопасность</div>
      <div className="conferenceSettings__switchersContainer">
        <div className="conferenceSettings__switchContainer">
          <span className="conferenceSettings__switchLabel">Зал ожидания</span>
          <SwitchSetting
            checked={!props.accessWaitingHall}
            onChange={(isChecked) => props.setAccessWaitingHall(isChecked ? 0 : 1)}
            data-testid="accessWaitingHall"
          />
        </div>
        <span className="conferenceSettings__informationText">
          К этой конференции могут присоединиться только пользователи, допущенные организатором
        </span>
      </div>
      <div className="conferenceSettings__title">Разрешить участникам</div>
      {switches.map((switchComponent, index) => (
        <div className="conferenceSettings__switchersContainer" key={index}>
          <div className="conferenceSettings__switchContainer">
            <span className="conferenceSettings__switchLabel">{switchComponent.label}</span>
            <SwitchSetting
              checked={switchComponent.checked}
              onChange={(isChecked) => onChangeSwitch(isChecked, switchComponent.onChange)}
              data-testid={switchComponent["data-testid"]}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConferenceSettings;
